import _ from "lodash"
import firebase from "gatsby-plugin-firebase"
import { navigate } from "gatsby-link"
import { toast } from "react-toastify"

export const isBrowser = () => typeof window !== "undefined"

// Get Workout Schedule
export const startSetWorkouts = () => {
  return (dispatch, getState) => {
    dispatch({
      type: "LOADING",
      data: true,
    })
    const uid = getState().auth.uid
    firebase
      .database()
      .ref(`users/${uid}/workouts`)
      .once("value")
      .then(snapshot => {
        dispatch(setWorkouts(snapshot.val()))
      })
      .then(() => {
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
      .catch(e => {
        console.log("Error: ", e)
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
  }
}

// Get Progress
export const startSetProgress = () => {
  return (dispatch, getState) => {
    dispatch({
      type: "LOADING",
      data: true,
    })
    const uid = getState().auth.uid
    return firebase
      .database()
      .ref(`users/${uid}/progress`)
      .once("value")
      .then(snapshot => {
        dispatch(setProgress(snapshot.val()))
        isBrowser() &&
          localStorage.setItem("progress", JSON.stringify(snapshot.val()))
      })
      .then(() => {
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
      .catch(e => {
        console.log("Error: ", e)
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
  }
}
// Get Meal Plan
export const startSetMealPlan = () => {
  return (dispatch, getState) => {
    dispatch({
      type: "LOADING",
      data: true,
    })
    const uid = getState().auth.uid
    return firebase
      .database()
      .ref(`users/${uid}/mealPlan`)
      .once("value")
      .then(snapshot => {
        dispatch(setMealPlan(snapshot.val()))
      })
      .then(() => {
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
      .catch(e => {
        console.log("Error: ", e)
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
  }
}

// Get Health Profile
export const startSetHealthProfile = () => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    firebase
      .database()
      .ref(`users/${uid}/health-profile`)
      .once("value")
      .then(snapshot => {
        dispatch(setHealthProfile(snapshot.val()))
      })
      .then(() => {
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
      .catch(e => {
        console.log("Error: ", e)
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
  }
}

// Get Profile
export const startSetProfile = () => {
  return (dispatch, getState) => {
    dispatch({
      type: "LOADING",
      data: true,
    })
    const uid = getState().auth.uid
    firebase
      .database()
      .ref(`users/${uid}/profile`)
      .once("value")
      .then(snapshot => {
        dispatch(setProfile(snapshot.val()))
      })
      .then(() => {
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
      .catch(e => {
        console.log("Error: ", e)
        dispatch({
          type: "LOADING",
          data: false,
        })
      })
  }
}

// Start Add Profile Data
export const startUpdateProfile = (profileData = {}) => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    const email = getState().auth.email
    let image = {}
    if (getState().profile) {
      image = getState().profile.image
    }
    const {
      title = "Mr.",
      firstName = "",
      lastName = "",
      gender = "Male",
      dateOfBirth = "",
      bloodGroup = "",
      address = "",
      phoneNumber = "",
      occupation = "",
    } = profileData
    const profile = {
      title,
      firstName,
      lastName,
      gender,
      dateOfBirth,
      bloodGroup,
      address,
      phoneNumber,
      occupation,
      email,
      image,
    }
    return firebase
      .database()
      .ref(`users/${uid}/profile`)
      .set(profile)
      .then(() => {
        dispatch(setProfile(profile))
      })
      .then(() => {
        toast.success(`Successfully updated profile!`)
      })
      .catch(e => {
        toast.error(`There was an error updating your profile. ${e}`)
      })
  }
}

// Start Add Health Questionnaire
export const startUpdateHealthProfile = (healthInfo = {}) => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    const {
      conditions = false,
      conditionsDescription = "",
      medication = false,
      medicationDescription = "",
      chestPain = false,
      chestPainDescription = "",
      backPain = false,
      backPainDescription = "",
      jointPain = false,
      jointPainDescription = "",
      bloodPressure = false,
      bloodPressureDescription = "",
      diabetes = false,
      diabetesDescription = "",
      stress = "moderate",
      smoker = false,
      smokerDescription = "",
      activity = "moderate",
      activityDescription = "",
      objectives = "",
      otherConditions = false,
      otherConditionsDescription = "",
    } = healthInfo
    const healthProfile = {
      conditions,
      conditionsDescription,
      medication,
      medicationDescription,
      chestPain,
      chestPainDescription,
      backPain,
      backPainDescription,
      jointPain,
      jointPainDescription,
      bloodPressure,
      bloodPressureDescription,
      diabetes,
      diabetesDescription,
      stress,
      smoker,
      smokerDescription,
      activity,
      activityDescription,
      objectives,
      otherConditions,
      otherConditionsDescription,
    }
    return firebase
      .database()
      .ref(`users/${uid}/health-profile`)
      .set(healthProfile)
      .then(() => {
        dispatch(setHealthProfile(healthProfile))
      })
      .then(() => {
        navigate("/app/dashboard")
        toast.success(`Successfully updated health profile!`)
      })
      .catch(e => {
        toast.error(`There was an error updating your profile. ${e}`)
      })
  }
}

export const addProgress = data => {
  return (dispatch, getState) => {
    const userId = getState().auth.uid
    const progress = getState().progress

    // // Save to Firebase Progress
    var newPostKey = firebase.database().ref().child(`progress`).push().key

    var updates = {}
    updates[`progress/` + newPostKey] = data
    updates[`users/${userId}/progress/` + newPostKey] = data

    firebase
      .database()
      .ref()
      .update(updates)
      .then(() => {
        if (progress) {
          progress[newPostKey] = data
          dispatch(setProgress(progress))
        } else {
          dispatch(
            setProgress({
              [newPostKey]: data,
            })
          )
        }
      })
      .then(() => {
        toast.success(`Successfully added new progress photo!`)
      })
      .catch(e => {
        toast.error(`There was an error uploading your progress photo. ${e}`)
      })
  }
}

// Delete Progress Photo
export const deleteProgress = progressId => {
  return (dispatch, getState) => {
    const userId = getState().auth.uid
    const progress = getState().progress

    var updates = {}
    updates[`progress/` + progressId] = null
    updates[`users/${userId}/progress/` + progressId] = null

    firebase
      .database()
      .ref()
      .update(updates)
      .then(() => {
        delete progress[progressId]
      })
      .then(() => {
        dispatch(setProgress(progress))
        toast.success(`Successfully deleted progress photo.`)
      })
      .catch(e => {
        toast.error(`There was an error deleting this meal!, ${e}`)
      })
  }
}

// Change Profile Picture
export const newProfilePicture = imageData => {
  return (dispatch, getState) => {
    const userId = getState().auth.uid
    const profile = getState().profile

    // // Save to Firebase
    firebase
      .database()
      .ref(`users/${userId}/profile/image`)
      .set(imageData)
      .then(() => {
        if (profile.image) {
          profile.image.url = imageData.url
          profile.image.thumbnail = imageData.thumbnail
        } else {
          profile.image = imageData
        }
      })
      .then(() => {
        dispatch(setProfile(profile))
        toast.success(`Successfully changed profile picture!`)
      })
      .catch(e => {
        toast.error(`There was an error changing your profile picture. ${e}`)
      })
  }
}

// Set Profile On Redux
export const setProfile = profile => {
  return dispatch => {
    isBrowser() && localStorage.setItem("profile", JSON.stringify(profile))
    dispatch({
      type: "SET_PROFILE",
      data: _.cloneDeep(profile),
    })
  }
}

// Set Workouts On Redux
export const setWorkouts = workouts => {
  return dispatch => {
    isBrowser() && localStorage.setItem("workouts", JSON.stringify(workouts))
    dispatch({
      type: "SET_WORKOUTS",
      data: workouts,
    })
  }
}

// Set Progress On Redux
export const setProgress = progress => {
  return dispatch => {
    isBrowser() && localStorage.setItem("progress", JSON.stringify(progress))
    dispatch({
      type: "SET_PROGRESS",
      data: _.cloneDeep(progress),
    })
  }
}

// Set Meal Plan On Redux
export const setMealPlan = mealPlan => {
  return dispatch => {
    isBrowser() && localStorage.setItem("mealPlan", JSON.stringify(mealPlan))
    dispatch({
      type: "SET_MEAL_PLAN",
      data: mealPlan,
    })
  }
}

// Set Health Profile On Redux
export const setHealthProfile = healthProfile => {
  return dispatch => {
    isBrowser() &&
      localStorage.setItem("healthProfile", JSON.stringify(healthProfile))
    dispatch({
      type: "SET_HEALTH_PROFILE",
      data: healthProfile,
    })
  }
}
